import React from 'react'
import PropTypes from 'prop-types'

function UserProfileTitle(props) {
    
    return (
        <div className="user-menu">
            <i className="fas fa-user" title="User Menu"></i>
            <span className="icon-text">{props.userName}</span>
        </div>

    )
}

UserProfileTitle.propTypes = {
    userName: PropTypes.string
}

export default UserProfileTitle
